export default [
  {
    title: "안전·보건 확보 의무이행 점검표",
    tableHeaderNote: [
      { text: '점검결과', width: '240' },
      { text: '조치사항', width: '240' },
    ],
    footer: "※ <span style='color: #EA5455'>(필수)</span> ① 항목별 증빙자료 첨부하되, 중복자료는 1건만 제출<br/>" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
      "② 증빙자료에는 이행사항별 식별번호 기재 예) 1-1~4, 7<br/><br/>" +
      "<p style='color: #7367F0'>※ 의무이행 점검표에 대한 증빙자료</p>" +
      "<p style='color: #7367F0'>- 시설별 사무분장표 또는 업무처리절차의 업무분담표, 업무처리절차 마련 결재본, 각종 안전점검 관련 계약서 및 정기검사결과서, 교육 실시 결과보고서(교육일지) 또는 의무교육 이수확인증(수료증), 유해위험요인 점검 체크리스트(점검대장), 보완 및 조치결과 등 제출</p>",
    list: [
      {
        title: "1. 인력배치 업무부여",
        content: "① 시설·설비 안전관리 및 유지보수 업무",
        isChecked: "",
      },
      {
        title: "1. 인력배치 업무부여",
        content: "② 유해물질 취급 안전관리 업무",
        isChecked: "",
      },
      {
        title: "1. 인력배치 업무부여",
        content: "③ 품질검사 및 제품 안전관리 업무",
        isChecked: "",
      },
      {
        title: "1. 인력배치 업무부여",
        content: "④ 유해·위험요인 점검 및 징후 발생시 대응업무",
        isChecked: "",
      },
      {
        title: "2. 예산편성 및 집행",
        content: "① 안전관리 업무 인력 확보·유지를 위한 예산",
        isChecked: "",
      },
      {
        title: "2. 예산편성 및 집행",
        content: "② 시설·설비 확보 유지를 위한 예산",
        isChecked: "",
      },
      {
        title: "2. 예산편성 및 집행",
        content: "③ 품질·기술기준 수준 유지를 위한 예산",
        isChecked: "",
      },
      {
        title: "2. 예산편성 및 집행",
        content: "④ 유해·위험요인 점검, 징후 발생시 대응 업무를 위한 예산",
        isChecked: "",
      },
      {
        title: "3. 업무처리절차마련",
        content: "① 유해·위험요인의 주기적 점검",
        isChecked: "",
      },
      {
        title: "3. 업무처리절차마련",
        content: "② 유해·위험요인 확인 결과 신고 및 조치의무",
        isChecked: "",
      },
      {
        title: "3. 업무처리절차마련",
        content: "③ 재해발생시 보고, 신고 및 조치의무",
        isChecked: "",
      },
      {
        title: "3. 업무처리절차마련",
        content: "④ 재해원인조사에 따른 개선조치",
        isChecked: "",
      },
      {
        title: "4. 의무이행에 필요한 관리상조치",
        content: "① 의무이행사항 점검",
        isChecked: "",
      },
      {
        title: "4. 의무이행에 필요한 관리상조치",
        content: "② 미이행시 조치",
        isChecked: "",
      },
      {
        title: "5. 법령상교육 실시점검",
        content: "① 교육실시 점검",
        isChecked: "",
      },
      {
        title: "5. 법령상교육 실시점검",
        content: "② 미이행시 조치",
        isChecked: "",
      },
      {
        title: "6. 재발방지대책",
        content: "① 재해발생 시 재발방지대책 수립 및 이행 조치",
        isChecked: "",
      },
      {
        title: "7. 개선·시정사항 이행",
        content: "① 중앙행정기관, 지자체개선·시정명령 이행조치",
        isChecked: "",
      },
    ],
  },
];
